import React from 'react';
import { Link } from 'react-router-dom';
import './Tuotannot.css';

const Tuotannot = () => {
    return (
        <div className="tuotannot-container">
            <div className="tuotannot-grid">
                <Link to="/tuotannot/elamyksia-vesilla" className="production-card taller-card">
                    <h3>Elämyksiä vesillä</h3>
                </Link>
                <Link to="/tuotannot/sodan-jaljet" className="production-card taller-card">
                    <h3>Sodan jäljet</h3>
                </Link>
            </div>
        </div>
    );
};

export default Tuotannot;